import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { Star4, Subtract1 } from '@components/icons/Illustrations/stars';
import { Union1 } from '@components/icons/Illustrations/unions';
import { Wave1 } from '@components/icons/Illustrations/waves';

export const VectorWithStars = () => {
  return (
    <IllustrationContainer>
      <SubtractContainer>
        <Subtract1 />
      </SubtractContainer>
      <StarContainer>
        <Star4 />
      </StarContainer>
      <WaveContainer>
        <Wave1 />
      </WaveContainer>
      <UnionContainer>
        <Union1 />
      </UnionContainer>
    </IllustrationContainer>
  );
};

const IllustrationContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  width: 228,
  height: 155,
});

const WaveContainer = styled('div', {
  margin: '0 auto',

  svg: {
    width: 220,
  },
});

const StarContainer = styled('div', {
  position: 'absolute',
  transform: 'translate(-8px, -40px)',

  svg: {
    width: 40,
  },
});

const SubtractContainer = styled('div', {
  position: 'absolute',
  transform: 'translate(150px, 10px)',

  svg: {
    width: 20,
  },
});

const UnionContainer = styled('div', {
  position: 'absolute',
  transform: 'translate(78px, -74px)',

  svg: {
    width: 43,
  },
});
